import {FormConfig} from '../../form/form.config';
import {FormModel} from '../../form/form.model.abstract';
import {Validators} from '@angular/forms';
import {FormModelRadio} from '../../form/form.model.radio';
import {EingabeStepComponent} from './eingabe.step.component';
import {ThermostatcheckAnfrage} from "../anfrage/thermostatcheck.anfrage";


/**
 * Configuration for the input in the thermostatcheck advisor.
 * @inheritDoc
 */
export class EingabeForm extends FormConfig {

  /**
   * (input) data of the user
   */
  stepComponent: EingabeStepComponent;

  /**
   * some data is needed here for validation
   */
  public anfrage: ThermostatcheckAnfrage;

  /**
   * @inheritDoc
   * @protected
   */
  protected fields: FormModel[] = [
    // basisdaten
    new FormModelRadio('nutzungstyp', ['mieter', 'wohnungseigentuemer', 'hauseigentuemer', 'hausverwalter'], [Validators.required], null, null, false),
    new FormModelRadio('gebaeudetyp', ['1-2familienhaus', 'mehrfamilienhaus'], [Validators.required], null, null, false),
    (new FormModelRadio('thermostatkopftyp', ['manuell', 'programmierbar', 'smart', 'raum'], [Validators.required], null, null, false)).setIconPath('/tec/icon-tec-'),
    new FormModelRadio('thermostatkopf_einbaujahr', ['bis_5', '6_bis_15', 'ab_15'], [Validators.required], null, null, false),
  ];

  /**
   * @inheritDoc
   * @protected
   */
  protected groups = {
    'kurz': ['nutzungstyp'],
    'basisdaten/1': ['nutzungstyp'],
    'basisdaten/2': ['gebaeudetyp'],
    'basisdaten/3': ['thermostatkopftyp'],
    'basisdaten/4': ['thermostatkopf_einbaujahr'],
  };

  /**
   * Sets stepComponent
   * @param stepComponent
   */
  setStepComponent(stepComponent: EingabeStepComponent): void {
    this.stepComponent = stepComponent;
  }

  /**
   * List of formfields where changes of the value, change other fields.
   */
  fieldsForFormChanges: string[] = [
    'thermostatkopftyp'
  ];

  /**
   * The options for some fields that are dynamic, depending on other form fields
   */
  static readonly options: any = {
    'thermostatkopf_einbaujahr': {
      'not_smart': ['bis_5', '6_bis_15', 'ab_15'],
      'smart': ['bis_5', '6_bis_15']
    }
  };

  /**
   * Any time a field is updated, this method is called.
   * @param values
   */
  updateFields(values: { [key: string]: any}): any {
    // in case of smart thermostat dont show option 15 years (15 Jahre und mehr)
    if(values.hasOwnProperty('thermostatkopftyp')) {
      if(values.thermostatkopftyp === 'smart') {
        this.setOptions('thermostatkopf_einbaujahr', EingabeForm.options.thermostatkopf_einbaujahr['smart']);
      }
      else {
        this.setOptions('thermostatkopf_einbaujahr', EingabeForm.options.thermostatkopf_einbaujahr['not_smart']);
      }
    }
  }

  /**
   * In this function all dynamic changes of the form is done.
   * Based on selection options or value other fields are shown/hidden, options changed and validators adapted.
   *
   * @inheritDoc
   * @param values
   * @protected
   */
  protected onSetData(values: { [key: string]: any }): void {
    this.updateFields(values);
  }

}
